/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxKamadoGrillComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxKamadoGrill').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'GRILL_LYNX_KAMADO',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-kamado-grill.js.map